export default __webpack_public_path__ + "static/media/rocket_anim_12.4f32664a.png";